var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameInteresting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9484 24.4C30.0583 24.4 28.514 25.7166 28.1695 27.4149L25.1641 26.8054C25.8011 23.6644 28.613 21.3334 31.9484 21.3334C35.7402 21.3334 38.8668 24.3543 38.8668 28.1451C38.8668 31.4098 36.5476 34.1036 33.4817 34.7883V36.2H30.4151V33.4901C30.4151 32.5931 31.1413 31.9 31.997 31.8898C34.1302 31.8643 35.8001 30.1693 35.8001 28.1451C35.8001 26.1055 34.1047 24.4 31.9484 24.4ZM32.0357 34.9562C32.035 34.9562 32.0343 34.9562 32.0337 34.9562L32.0337 34.9562C32.0343 34.9562 32.035 34.9562 32.0357 34.9562Z",
    fill: "#current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.4668,
    y: 38.4667,
    width: 3.06667,
    height: 3.06667,
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM32 61.5C48.2924 61.5 61.5 48.2924 61.5 32C61.5 15.7076 48.2924 2.5 32 2.5C15.7076 2.5 2.5 15.7076 2.5 32C2.5 48.2924 15.7076 61.5 32 61.5Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameInteresting);
export default __webpack_public_path__ + "static/media/game-interesting.3d29699ef51d8833b84b43e8dab75a2d.svg";
export { ForwardRef as ReactComponent };